import { type DuroRouteObject } from '~/shared/routing/types';
import { LegacySchedulingPage } from './scheduling/LegacySchedulePage';
import { WoundPatients } from './wounds/WoundPatients';
import { LegacyHospitalizationsPage } from './hospitalizations/LegacyHospitalizationsPage';
import { LegacyReferralsPage } from './referrals/LegacyReferralsPage';
import { PatientsLegacyHospitalizations } from './hospitalizations/PatientsLegacyHospitalizations';
import { useParams } from 'react-router-dom';
import { SuspenseWrapper } from '~/shared/SuspenseWrapper';
import { LegacyReferralPage } from './referrals/LegacyReferralPage';
import { LegacyOasisTracking } from './oasis/LegacyOasisTracking';

export const legacyRoutes: DuroRouteObject[] = [
	{
		path: 'legacy-schedule',
		element: <LegacySchedulingPage />,
		handle: { menuLabel: 'Schedule', disableBreadCrumb: true, disableBack: true, legacyRoute: true }
	},
	{
		path: 'legacy-wound-patients',
		element: <WoundPatients />,
		handle: { menuLabel: 'Wound Patients', disableBreadCrumb: true, disableBack: true, legacyRoute: true }
	},
	{
		path: 'oasis-tracking',
		element: <LegacyOasisTracking />,
		handle: { menuLabel: 'OASIS Tracking', disableBreadCrumb: true, disableBack: true, legacyRoute: true }
	},
	{
		path: 'patienthospitalizations',
		children: [
			{
				index: true,
				element: <LegacyHospitalizationsPage />,
				handle: { menuLabel: 'All Hospitalizations', disableBreadCrumb: true, disableBack: true, legacyRoute: true }
			},
			{
				path: ':sponsorMrn/:stayUuid',
				element: <PatientsLegacyHospitalizationsRoute />,
				handle: { menuLabel: 'Patient Hospitalization Details', disableBreadCrumb: true, disableBack: false, legacyRoute: true }
			}
		]
	},
	{
		path: 'legacy-referrals',
		children: [
			{
				index: true,
				element: <LegacyReferralsPage />,
				handle: { menuLabel: 'All Referrals', disableBreadCrumb: true, disableBack: true, legacyRoute: true }
			},
			{
				path: ':referralId',
				element: <LegacyReferralPage />,
				handle: { menuLabel: 'Referral Details', disableBreadCrumb: true, disableBack: false, legacyRoute: true }
			}
		]
	}
];

function PatientsLegacyHospitalizationsRoute() {
	const params = useParams<'sponsorMrn' | 'stayUuid'>();
	if (!params.sponsorMrn || !params.stayUuid) {
		throw new Error('sponsorMrn and stayUuid are required in the URL parameters');
	}
	return (
		<SuspenseWrapper key={params.stayUuid} name="PatientsLegacyHospitalizationsRoute">
			<PatientsLegacyHospitalizations sponsorMrn={params.sponsorMrn} stayUuid={params.stayUuid} />
		</SuspenseWrapper>
	);
}
